function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Chat Bubble Icon");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M14.2998,0.4996 C16.0671256,0.4996 17.4998,1.93264089 17.4998,3.7006 L17.4998,10.6066 C17.4998,12.3745591 16.0671256,13.8076 14.2998,13.8076 L9.78151025,13.8076 L5.09188585,17.325968 C4.7180545,17.5978454 4.1928,17.332054 4.1928,16.8686 L4.1928,13.8076 L3.6998,13.8076 C1.93247439,13.8076 0.4998,12.3745591 0.4998,10.6066 L0.4998,3.7006 C0.4998,1.93264089 1.93247439,0.4996 3.6998,0.4996 L14.2998,0.4996 Z M14.2998,1.4996 L3.6998,1.4996 C2.48481641,1.4996 1.4998,2.48486839 1.4998,3.7006 L1.4998,10.6066 C1.4998,11.8223316 2.48481641,12.8076 3.6998,12.8076 L5.1928,12.8076 L5.1928,16.0001696 L9.4480872,12.8076 L14.2998,12.8076 C15.5147836,12.8076 16.4998,11.8223316 16.4998,10.6066 L16.4998,3.7006 C16.4998,2.48486839 15.5147836,1.4996 14.2998,1.4996 Z M9,7.5 C9.27614237,7.5 9.5,7.72385763 9.5,8 C9.5,8.27614237 9.27614237,8.5 9,8.5 L5,8.5 C4.72385763,8.5 4.5,8.27614237 4.5,8 C4.5,7.72385763 4.72385763,7.5 5,7.5 L9,7.5 Z M12,4.5 C12.2761424,4.5 12.5,4.72385763 12.5,5 C12.5,5.27614237 12.2761424,5.5 12,5.5 L5,5.5 C4.72385763,5.5 4.5,5.27614237 4.5,5 C4.5,4.72385763 4.72385763,4.5 5,4.5 L12,4.5 Z",
  id: "chat-bubble-path-1"
}));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "chat-bubble-Icon/Global/Message",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "chat-bubble-Swatches/DarkGreen",
  transform: "translate(3.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("use", {
  id: "chat-bubble-Mask",
  fill: "currentcolor",
  fillRule: "nonzero",
  xlinkHref: "#chat-bubble-path-1"
})));

var SvgChatBubble = function SvgChatBubble(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChatBubble, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/chat-bubble.69c165a5.svg";
export { ForwardRef as ReactComponent };